import Swiper from 'swiper';
import { Navigation, Pagination, Grid, Thumbs, Autoplay } from 'swiper/modules';
window.Swiper = Swiper;

window.SwiperModes = {
    'Navigation': Navigation,
    'Pagination': Pagination,
    'Grid': Grid,
    'Thumbs': Thumbs,
    'Autoplay': Autoplay
};

let mainSlider = new Swiper('#main_slider', {
    modules: [Pagination, Autoplay],
    slidesPerView: 1,
    pagination: {
        el: '.main-slider__pagination',
        clickable: true,
        bulletClass: 'main-slider__pagination-item',
        bulletActiveClass: 'main-slider__pagination-item_active'
    },
    speed: 2000,
    loop: true,
    autoplay: $('#main_slider').data('autoplay') == 1 ? { delay: $('#main_slider').data('delay') * 1000 } : false,
})

let catalogsSlider = new Swiper('#catalogs_slider', {
    modules: [Pagination],
    slidesPerView: 1,
    loop: true,
    breakpoints: {
        768: {
            enabled: false
        }
    },
    pagination: {
        el: '.catalogs__pagination',
        clickable: true,
        bulletClass: 'catalogs__pagination-item',
        bulletActiveClass: 'catalogs__pagination-item_active'
    },
})


let goodsGallery = new Swiper('.swiper-gallery', {
    modules: [Pagination],
    slidesPerView: 1,
    loop: true,
    breakpoints: {
        1024: {
            enabled: false
        }
    },
    pagination: {
        el: '.goods__gallery-pagination',
        clickable: true,
        bulletClass: 'goods__gallery-pagination-item',
        bulletActiveClass: 'active'
    },
})

$('.js_collections__slider-wrapper').each(function () {
    const wrapper = $(this).closest('.js_collection__tile-holder');

    let collectionSlider = new Swiper($(this)[0], {
        spaceBetween: 20,
        loop: true,
        slidesPerView: 1,
        breakpoints: {
            1536: {
                slidesPerView: 4,
            },
            1024: {
                slidesPerView: 3,
            },
            568: {
                slidesPerView: 2,
            }
        },
    });
    
    wrapper.find('.js_collection__tile-prev').on('click', function () {
        collectionSlider.slidePrev()
    })

    wrapper.find('.js_collection__tile-next').on('click', function () {
        let length = collectionSlider.slides.length
        let activeIndex = collectionSlider.activeIndex
        let num = 1

        switch (collectionSlider.currentBreakpoint) {
            case '568':
                num = 2
                break;
            case '1024':
                num = 3
                break;
            case '1536':
                num = 4
                break;
        }

        if (activeIndex + num == length) {
            collectionSlider.slideTo(0)
        } else {
            collectionSlider.slideNext();
        }
    })
});

let categoriesSlider = new Swiper('#categories_slider', {
    modules: [Navigation],
    loop: true,
    spaceBetween: 20,
    slidesPerView: 1,
    breakpoints: {
        1536: {
            slidesPerView: 7,
        },
        1024: {
            slidesPerView: 5,
        },
        768: {
            slidesPerView: 3,
        },
        568: {
            slidesPerView: 2,
        }
    }
})
$('.js_categories__prev').on('click', function () {
    categoriesSlider.slidePrev()
})
$('.js_categories__next').on('click', function () {
    let length = categoriesSlider.slides.length
    let activeIndex = categoriesSlider.activeIndex
    let num = 1

    switch (categoriesSlider.currentBreakpoint) {
        case '568':
            num = 2
            break;
        case '768':
            num = 3
            break;
        case '1024':
            num = 5
            break;
        case '1536':
            num = 7
            break;
    }

    if (activeIndex + num == length) {
        categoriesSlider.slideTo(0)
    } else {
        categoriesSlider.slideNext();
    }
})

let doubleCover = new Swiper('#double-cover', {
    modules: [Pagination],
    slidesPerView: 1,
    loop: true,
    breakpoints: {
        568: {
            enabled: false
        }
    },
    pagination: {
        el: '.goods__double-cover-pagination',
        clickable: true,
        bulletClass: 'goods__double-cover-pagination-item',
        bulletActiveClass: 'active'
    },
})

let doubleGallery = new Swiper('.swiper-double-gallery', {
    modules: [Pagination],
    slidesPerView: 1,
    slidesPerGroup: 1,
    loop: true,
    spaceBetween: 20,
    breakpoints: {
        1024: {
            enabled: false
        },
        568: {
            slidesPerView: 2,
            slidesPerGroup: 2
        },
    },
    pagination: {
        el: '.goods__gallery-pagination',
        clickable: true,
        bulletClass: 'goods__gallery-pagination-item',
        bulletActiveClass: 'active'
    },
})

const sliderTool = {
    sliderInit: function(sliderEl) {
        let wrapper = $(sliderEl).closest('.js_slider-wrapper')
        let slidesNum = $(sliderEl).attr('data-slides')
        let prevBtn = wrapper.find('.js_slider__btn_prev')
        let nextBtn = wrapper.find('.js_slider__btn_next')
        let slidesBreakpoint = {
            1536: {
                slidesPerView: 4,
            },
            1024: {
                slidesPerView: 3,
            },
            568: {
                slidesPerView: 2,
            }
        }
        if (slidesNum > 4) {
            slidesBreakpoint['1920'] = {
                slidesPerView: slidesNum,
            }
        }
        let slider = new Swiper(sliderEl, {
            spaceBetween: 20,
            loop: true,
            slidesPerView: 1,
            breakpoints: slidesBreakpoint,
            navigation: {
                prevEl: prevBtn[0],
                nextEl: nextBtn[0],
            },
            modules: [Navigation],
            on: {
                init: function() {
                    sliderTool.buttonPosition(sliderEl)
                    sliderTool.titleHeigth(sliderEl)
                }
            }
        })
    },
    buttonPosition: function(sliderEl) {
        let wrapper = $(sliderEl).closest('.js_slider-wrapper')
        let prevBtn = wrapper.find('.js_slider__btn_prev')
        let nextBtn = wrapper.find('.js_slider__btn_next')
        let imgHeigth = wrapper.find('.js_card__main-image').eq(0).innerHeight() / 2 - prevBtn.innerHeight() / 2
        prevBtn.removeAttr('style').css('top', imgHeigth)
        nextBtn.removeAttr('style').css('top', imgHeigth)
    },
    titleHeigth: function(sliderEl) {
        let titleHeigth = 0
        let sliderElements = $(sliderEl).find('.js_card__main-name')
        sliderElements.each((i,el) => {
            $(el).removeAttr('style')
            $(el).innerHeight() > titleHeigth ? titleHeigth = $(el).innerHeight() : ''
        })
        sliderElements.each((i,el) => {
            $(el).css('height', titleHeigth)
        })
    }
}

$(document).ready(function() {
    $('.js_slider').each((i,el) => {
        sliderTool.sliderInit(el)
    })
})

$(window).on('resize', function() {
    $('.js_slider').each((i,el) => {
        sliderTool.buttonPosition(el)
        sliderTool.titleHeigth(el)
    })
})

paginationDisabled()

function paginationDisabled() {
    let wrapper = $('.main-slider__pagination').closest('.main-slider')
    let length = wrapper.find('.main-slider__item').length
    if (length === 1) {
        wrapper.find('.main-slider__pagination').addClass('disabled')
    }
}
